import { styled } from '@/stitches.config';

import { ReactComponent as RightArrowIcon } from '@assets/icons/arrow-right.svg';

import { Box } from '@base-app';

export const StyledBodySamples = styled(Box, {
  display: 'flex',
});

export const StyledContent = styled(Box, {
  alignItems: 'baseline',
  display: 'flex',
  flexDirection: 'column',
});

export const StyledContentSeparator = styled(Box, {
  borderRight: '$borderWidths$2 solid $seafoam500',
  height: '80px',
  margin: '0 $5',
});

export const StyledTotalDetails = styled(Box, {
  color: '$darkBlue400',
  fontSize: '$4',
  fontWeight: '$medium',
  lineHeight: '$6',
});

export const StyledButtonContainer = styled(Box, {
  margin: '$10 0 0 0',
});

export const StyledRightArrowIcon = styled(RightArrowIcon, {});

export const StyledAccentColor = styled(Box, {
  height: '6px',
  marginBottom: '$8',
  width: '$6',
});
